import { Button } from '@global-engineering-shared/gweb-material-ui';
import React, { useEffect, useState } from 'react';

import { useFilters } from 'context/FilterProvider/FilterProvider';
import useStyles from 'features/Filters/FilterPanel/FilterPanel.styles';
import MultipleFilters from 'features/Filters/MultipleFilters/MultipleFilters';
import SpaceIdsInput from 'features/Filters/SpaceIdsInput/SpaceIdsInput';
import { Filter, Filters } from 'features/Filters/types/Filters';
import { defaultFilters } from 'features/Filters/utils/defaultFilters';
import { filterSpaceIds } from 'features/Filters/utils/filterValues';
import useFetchData from 'hooks/useFetchData';
import { FILTERS_API_URL } from 'utils/defaults';
import { getOptionsForFilter } from 'utils/filter';

type FilterPanelProps = {
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  filterValues: Filter[];
};

const FilterPanel = ({ setDrawerOpen, filterValues }: FilterPanelProps) => {
  const classes = useStyles();
  const [filterData, setFilterData] = useState<Filters>(defaultFilters);
  const [selectedFilters, setSelectedFilters] = useState<Filters>({} as Filters);
  const [filterResponse, setFilterOptions] = useState<Filters>(defaultFilters);
  const { setFilters, filters, currentFiltersPage } = useFilters();
  const { getData } = useFetchData();

  const submitFilters = () => {
    setFilters(selectedFilters);
    setDrawerOpen(false);
  };

  useEffect(() => {
    getData<Filters>(FILTERS_API_URL + '?type=' + currentFiltersPage, (data) => {
      setFilterData(data);
    });
  }, []);

  useEffect(() => {
    const loadData = async () => {
      if (!filterData) return;
      setFilterOptions((prev) => ({
        ...prev,
        ...filterData,
      }));
    };
    loadData();
  }, [filterData]);

  useEffect(() => {
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      ...filters,
    }));
  }, [filters]);

  return (
    <div className={classes.filterComponent}>
      <span>
        {filterValues.map((filter) => (
          <MultipleFilters
            label={filter.label}
            options={getOptionsForFilter(filter.key, filterResponse)}
            setSelectedFilters={setSelectedFilters}
            filterKey={filter.key}
            filters={filters}
          />
        ))}
        {filterSpaceIds.map((filter) => (
          <SpaceIdsInput
            options={getOptionsForFilter(filter.key, filterResponse)}
            setSelectedFilters={setSelectedFilters}
            filterKey={filter.key}
          />
        ))}
      </span>
      <Button onClick={submitFilters} className={classes.applyButton}>
        Apply
      </Button>
    </div>
  );
};

export default FilterPanel;
